import styled from "@emotion/styled";

const SectionWrapper = styled.div`
  min-height: calc(100vh - 150px);
  display: flex;
  align-items: center;
  /* background-color: ${(props) =>
    props.bgColor ? props.bgColor : "#000000"}; */
  /* padding: ${(props) => (props.p ? props.p : "1.5rem 0")}; */
  margin: ${(props) => (props.m ? props.m : "0")};
  @media screen and (max-width: 599px) {
    min-height: calc(100vh - 178px);
  }
`;
const P = styled.p`
  font-family: "Poppins-Regular";
  background-color: rgba(13, 119, 87, 0.15);
  color: #fff;
  border-radius: 20px;
  padding: 20px 20px;
  backdrop-filter: blur(20px);
  font-size: ${(props) => (props.fs ? props.fs : "18px")};
  /* color: ${(props) => (props.color ? props.color : "#ffffff")};   */
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin-top: ${(props) => (props.mt ? props.mt : "0px")};
  margin-bottom: ${(props) => (props.mb ? props.mb : "20px")};
  margin-left: ${(props) => (props.ml ? props.ml : "0px")};
  margin-right: ${(props) => (props.mr ? props.mr : "0px")};

  @media (max-width: 899px) {
    font-size: 14px;
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    /* padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")}; */
  }
`;
const CustomContainer = styled.div`
  max-width: 2600px;
`;
const SectionHeading = styled.h2`
  color: #0d7757;
  display: inline-block;
  font-size: 100px;
  font-weight: 400;
  font-family: "rhinos";
  text-transform: uppercase;
  margin: ${(props) => (props.m ? props.m : "")};
  @media (max-width: 899px) {
    font-size: 50px;
  }
  @media (max-width: 599px) {
    font-size: 30px;
  }
`;
const SectionSubHeading = styled.h3`
  font-family: "Poppins-ExtraBoldItalic";
  font-size: ${(props) => (props.fs ? props.fs : "59px")};
  text-transform: ${(props) => (props.tt ? props.tt : "lowercase")};

  color: #ffffff;

  line-height: ${(props) => (props.lh ? props.lh : "")};
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "center")};

  @media (max-width: 599px) {
    line-height: ${(props) => (props.lh ? props.lh : "")};
    max-width: 100%;
    font-size: ${(props) => (props.fs599 ? props.fs599 : "")};
  }
`;

export {
  SectionWrapper,
  P,
  SectionHeading,
  SectionSubHeading,
  CustomContainer,
};
